import {
  animate,
  animateChild,
  group,
  query,
  stagger,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const ST_EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

/**
 * Left-hand intro copy: opacity 0 -> 1, translateY(26px) -> 0.
 * `animateChild` keeps the nested card stagger from being swallowed.
 */
export const stFade = trigger('stFade', [
  state('hidden', style({ opacity: 0, transform: 'translateY(26px)' })),
  state('shown', style({ opacity: 1, transform: 'none' })),
  transition('hidden => shown', [
    group([
      animate(`520ms ${ST_EASE}`),
      query('@*', animateChild(), { optional: true }),
    ]),
  ]),
]);

/** The six pillar cards land row by row. */
export const stCards = trigger('stCards', [
  transition('hidden => shown', [
    query('.st-card', style({ opacity: 0, transform: 'translateY(24px) scale(0.97)' }), {
      optional: true,
    }),
    query(
      '.st-card',
      stagger(80, [
        animate(`460ms ${ST_EASE}`, style({ opacity: 1, transform: 'none' })),
      ]),
      { optional: true }
    ),
  ]),
]);

/** Vision then Mission rise in together, a beat apart. */
export const stPanels = trigger('stPanels', [
  transition('hidden => shown', [
    query('.st-vm', style({ opacity: 0, transform: 'translateY(30px)' }), {
      optional: true,
    }),
    query(
      '.st-vm',
      stagger(130, [
        animate(`540ms ${ST_EASE}`, style({ opacity: 1, transform: 'none' })),
      ]),
      { optional: true }
    ),
  ]),
]);
